import { IssuerEnv } from './oauth.interfaces';
export interface OauthAEMConfig extends OptionalOauthAEMConfig {
  AUTHORIZATION_CODE: string;
  CLIENT_ID: string;
  CLIENT_ID_VALUE: string;
  CODE: string;
  CODE_CHALLENGE: string;
  CODE_CHALLENGE_METHOD: string;
  CODE_CHALLENGE_METHOD_VALUE: string;
  CODE_VERIFIER: string;
  COMPLETED: string;
  ENABLE_PING_LOGOUT: boolean;
  GRANT_TYPE: string;
  IS_USER_REMEMBERED: string;
  ISSUER_PROD: string;
  LOG_OUT_URL: string;
  OAUTH2: string;
  OAUTH2_TOKEN: string;
  OAUTH2_USER_CREDENTIALS: string;
  OPEN_ID: string;
  PERSISTENT_COOKIE_TIMER: number;
  PING_DOMAIN: string;
  PROMPT: string;
  PROMPT_VALUE: string;
  REMEMBERED_DEVICE_DETAILS: string;
  RESPONSE_MODE: string;
  RESPONSE_MODE_VALUE: string;
  RESPONSE_TYPE: string;
  RESPONSE_TYPE_VALUE: string;
  SCOPE: string;
  SCOPE_VALUE: string; // SCOPE_VALUE must be the same as SCOPE_VALUE_RM
  SCOPE_VALUE_RM: string; // SCOPE_VALUE must be the same as SCOPE_VALUE_RM
  SHOULD_REMEMBER_USER: string;
  USERNAME_PASSWORD_REQUIRED: string;
}

export interface OptionalOauthAEMConfig {
  MFA_SCOPE_VALUE?: string;
  MFA_CLIENT_ID_VALUE?: string;
  MFA_ACTION?: string;
  MFA_ACTION_VALUE?: string;
  MFA_ACTION_SSPR_VALUE?: string;
  ISSUER?: IssuerEnv[];
  PERSISTENT_LOGIN_ENABLE?: boolean;
  LEVEL_OF_TRUST?: string;
  LEVEL_OF_TRUST_VALUE?: string;
  PERSISTENT_COOKIE_TIMER?: number;
  REMEMBERME_API_FLOW_ENABLE?: boolean;
  VERSION_PARAMETER?: string;
  VERSION_PARAMETER_VALUE?: string;
  VERIFY_EMAIL_MFA?: string;
  VERIFY_EMAIL_MFA_VALUE?: string;
  ISSUER_WIFI_PORTAL?: string;
  RESUME?: string;
  INTROSPECTION?: string;
  INTROSPECTION_CLIENT?: string;
  PING_FLOW_ENABLED?: boolean;
  BFF_CODES_TO_IGNORE?: string;
  NU_TRAVEL_URL?: string[];
  IS_EMAIL_ALLOWED?: boolean;
  ACCOUNT_RECOVERY_FLOW_ENABLED?: boolean;
  BAU_URLS?: string[];
  COOKIE_DOMAIN?: string;
  COOKIE_DOMAIN_VALUE?: string;
  LOGIN_URLS?: string[];
  REDIRECTION_URLS?: string[];
  PHASE_ONE_URLS?: string[];
  REDIRECT_REFRESH_URLS?: string[];
  LOGIN_PICKER?: string;
  LOGIN_PICKER_STANDALONE?: string;
  DELETE_STANDALONE_COOKIE?: boolean;
  MAKE_PE_CALL?: boolean;
  ENABLE_NEW_PROFILE_SELECTOR?: boolean;
  FTWR_LOGIN_MODAL_COOKIE_AGE?: number;
  ENABLE_NEW_PERSISTENT_LOGIN?: boolean;
  REGISTER_SW_URL?: string;
  EAM_OUTAGE_ERROR_CODE_IGNORE?: string[];
  ACCESS_TOKEN_REFRESH_TIME?: number;
  APP_PROFILE_GRAPHQL_ENDPOINT?: string;
  DIGITAL_ID_ENABLED?: boolean;
  LOGIN_STANDALONE_PAGE_URL?: string;
  AWS_ACCOUNT_RECOVERY_FLOW_ENABLED?: boolean;
  ORION_FLYOUT?: boolean;
  CLEAR_CKO_COOKIE?: boolean;
  PROFILE_PAGE_URL?: string;
  NEW_RESET_PASSWORD_FLOW?: boolean;
  MFA_FLOW?: boolean;
  FLY_DELTA_POLLING_TIMER?: number;
  VERIFICATION_SCREEN_TIMER?: number;
  ONE_TIME_PASSCODE_TIMER?: number;
  MFA_URLS?: string[];
  FLY_DELTA_POLLING_APP_NAME?: string;
  FLY_DELTA_COOL_DOWN_TIME?: number;
  MFA_SETUP_LATER_TIMER?: number;
  REGISTRATION_RETRY_COUNT?: number;
  REGISTRATION_RETRY_TIMER?: number;
  DISABLE_SQA_SCREEN?: boolean;
  WIFI_SESSION_STORAGE?: boolean;
  TOKEN_HEADER?: boolean;
  MFA_TIMEOUT?: number;
  LOGIN_TIMEOUT?: number;
  LOGIN_RETRY_COUNT?: number;
  LOGIN_RETRY_TIMER?: number;
  MFA_STUDIO_CONFIG_ID?: string;
  APP_SAVED_SEARCH_API_GRAPHQL?: string;
  SAVED_SEARCH_GRAPHQL_CLIENT_ID_VALUE?: string;
  SAVED_SEARCH_GRAPHQL_SCOPE_VALUE?: string;
  REMAINING_OTP_ATTEMPT?: number;
  REFRESH_TOKEN_TIME?: number;
  RESTRICT_AUTH_CALLS_URL?: string[];
  PUSH_NOTIFICATION_TIMER?: number;
  ERROR_428?: boolean;
  MAKE_SERVER_PE_CALL?: boolean;
  HEADER_CLIENT_ID_VALUE?: string;
  GET_SAVED_TRIPS_AWS_API_FLAG?: boolean;
  TRIPS_API_AWS?: boolean;
  PROFILE_BFF_AWS?: boolean;
  TRIP_SEARCH_AWS?: boolean;
  CASE_STATUS_AWS?: boolean;
  POST_CORPORATE_ID_FLAG?: boolean;
  NGC_COOKIE_BANNER_ENABLE?: boolean;
  X_EAM_AUTHN_STATE_ENV?: string;
  NEXT_GEN_MY_TRIPS?: boolean;
  NEXT_GEN_MY_TRIPS_URL?: string;
  NO_LAST_NAME?: boolean;
  NAME_LENGTH_CONFIG?: boolean;
}
